import React, { useState } from 'react';
import { getMediaUrl } from '../services/api';

const ClientBlogsSection = () => {
  const [blogs] = useState([
    {
      id: 1,
      title: 'Understanding Mental Health in the Modern World',
      date: 'March 15, 2024',
      author: 'Dr. John Doe',
      category: 'Mental Health',
      image: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80',
      excerpt: 'Learn about the importance of mental health and how to maintain a balanced lifestyle.'
    },
    {
      id: 2,
      title: 'Coping Strategies for Anxiety Disorders',
      date: 'March 10, 2024',
      author: 'Dr. Jane Smith',
      category: 'Anxiety',
      image: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80',
      excerpt: 'Discover effective techniques to manage anxiety and improve your quality of life.'
    },
    {
      id: 3,
      title: 'The Power of Mindfulness and Meditation',
      date: 'March 5, 2024',
      author: 'Dr. Mike Johnson',
      category: 'Mental Health',
      image: 'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=400&q=80',
      excerpt: 'Explore how mindfulness can transform your mental health and daily experiences.'
    },
    {
      id: 4,
      title: 'Building Healthy Relationships',
      date: 'February 28, 2024',
      author: 'Dr. John Doe',
      category: 'Relationships',
      image: 'https://images.unsplash.com/photo-1454023492550-5696f8ff10e1?auto=format&fit=crop&w=400&q=80',
      excerpt: 'Essential tips for developing and maintaining meaningful relationships.'
    },
    {
      id: 5,
      title: 'Sleep and Mental Health Connection',
      date: 'February 20, 2024',
      author: 'Dr. Jane Smith',
      category: 'Sleep',
      image: 'https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=400&q=80',
      excerpt: 'Understanding the crucial link between sleep quality and mental wellness.'
    },
    {
      id: 6,
      title: 'Stress Management in the Workplace',
      date: 'February 15, 2024',
      author: 'Dr. Mike Johnson',
      category: 'Stress Management',
      image: 'https://images.unsplash.com/photo-1503676382389-4809596d5290?auto=format&fit=crop&w=400&q=80',
      excerpt: 'Practical strategies for maintaining mental health while working.'
    }
  ]);

  const [selectedCategory, setSelectedCategory] = useState('All');

  const categories = ['All', 'Mental Health', 'Anxiety', 'Depression', 'Relationships', 'Sleep', 'Stress Management'];
  const filteredBlogs = selectedCategory === 'All' 
    ? blogs 
    : blogs.filter(blog => blog.category === selectedCategory);

  return (
    <div style={{ padding: '20px' }}>
      <h3 style={{ margin: '0 0 20px 0', fontSize: '24px', fontWeight: 'bold', color: '#1f2937' }}>
        📚 Mental Health Blog & Insights
      </h3>
      <p style={{ color: '#6b7280', marginBottom: '20px' }}>
        Explore expert articles and tips on mental health, wellness, and personal growth.
      </p>

      {/* Category Filter */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '30px', flexWrap: 'wrap' }}>
        {categories.map(cat => (
          <button
            key={cat}
            onClick={() => setSelectedCategory(cat)}
            style={{
              padding: '8px 16px',
              background: selectedCategory === cat 
                ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
                : '#f0f0f0',
              color: selectedCategory === cat ? 'white' : '#333',
              border: 'none',
              borderRadius: '20px',
              fontWeight: '600',
              cursor: 'pointer',
              fontSize: '13px',
              transition: 'all 0.3s'
            }}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Blogs Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: '20px'
      }}>
        {filteredBlogs.map(blog => (
          <div
            key={blog.id}
            style={{
              background: 'white',
              borderRadius: '12px',
              overflow: 'hidden',
              boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
              transition: 'transform 0.3s, box-shadow 0.3s',
              cursor: 'pointer'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'none';
              e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.05)';
            }}
          >
            {/* Blog Image */}
            <div style={{
              height: '180px',
              backgroundImage: `url(${getMediaUrl(blog.image)})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                top: '12px',
                right: '12px',
                background: '#667eea',
                color: 'white',
                padding: '6px 12px',
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: '600'
              }}>
                {blog.category}
              </span>
            </div>

            {/* Blog Content */}
            <div style={{ padding: '16px' }}>
              <h4 style={{
                margin: '0 0 8px 0',
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#1f2937',
                lineHeight: '1.4'
              }}>
                {blog.title}
              </h4>

              <p style={{
                margin: '8px 0 12px 0',
                fontSize: '13px',
                color: '#6b7280',
                lineHeight: '1.5',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden'
              }}>
                {blog.excerpt}
              </p>

              {/* Author & Date */}
              <div style={{
                paddingTop: '12px',
                borderTop: '1px solid #e5e7eb',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontSize: '12px',
                color: '#9ca3af'
              }}>
                <span>👤 {blog.author}</span>
                <span>📅 {blog.date}</span>
              </div>

              {/* Read More Button */}
              <button style={{
                width: '100%',
                padding: '10px',
                marginTop: '12px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontWeight: '600',
                fontSize: '13px',
                cursor: 'pointer',
                transition: 'opacity 0.2s'
              }}
              onMouseEnter={e => e.target.style.opacity = '0.9'}
              onMouseLeave={e => e.target.style.opacity = '1'}
              >
                Read More →
              </button>
            </div>
          </div>
        ))}
      </div>

      {filteredBlogs.length === 0 && (
        <div style={{
          padding: '40px',
          textAlign: 'center',
          color: '#9ca3af',
          background: '#f9fafb',
          borderRadius: '12px'
        }}>
          No blogs found in this category.
        </div>
      )}
    </div>
  );
};

export default ClientBlogsSection;
